






































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { MetaInfo } from 'vue-meta'
import { userType, common } from '@/app/model/store/domain/const'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
/* module */
import CommonClass from '@/app/module/common'
import VarietyListApi from '@/app/model/api/varietyListApi'
import DistrictListApi from '@/app/model/api/districtListApi'
import NewsBoardDetailApi from '@/app/model/api/newsBoardDetailApi'
import NewsBoardContentListApi from '@/app/model/api/newsBoardContentListApi'
import GetNewsBoardFileApi from '@/app/model/api/getNewsBoardFileApi'
import Local from '@/app/module/local'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    Loading,
    Error409Modal,
    DeleteModal,
    ErrorModal,
    ErrorInfo
  },
  metaInfo (this: NewsBoardDetails): MetaInfo {
    return {
      title: CommonClass.getServiceFunctionData().news_board.news_board_name + '詳細 | ' + common.SYSTEM_NAME
    }
  }
})
export default class NewsBoardDetails extends Vue {
  private alertText: string = ''
  private alertTitle: string = ''
  private newsBoardId: string = ''
  private newsBoardDetailData: any = {}

  /* 表示非表示 */
  private showLoading: boolean = true
  private showServerErrorModal: boolean = false
  private showError409Modal: boolean = false
  private show400ErrorMessage: boolean = false
  private isAdmin: boolean = false
  private varietyData: any = []
  private districtData: any = []
  private varietyIdsData: any = []
  private districtIdsData: any = []
  private newsBoardContentData: any = []
  private newsBoardTitle: string = ''

  created () {
    if (Local.getUserType() === String(userType.USER_TYPE_ADMIN)) {
      this.isAdmin = true
    }
    this.getVarieties()
    this.getDistricts()

    this.newsBoardTitle = CommonClass.getServiceFunctionData().news_board.news_board_name
    this.newsBoardId = this.$route.params.news_board_id
    this.getNewsBoardDetail(this.newsBoardId)
    this.getNewsBoardContent(this.newsBoardId)
  }

  private getNewsBoardDetail (newsBoardId: string) {
    (async () => {
      const result = await NewsBoardDetailApi.getDetail(newsBoardId)
      if (result.isOk()) {
        const payload = result.getPayload()
        this.newsBoardDetailData = payload
        this.varietyIdsData = this.choiceVarietyOptions(payload.variety.variety_options)
        this.districtIdsData = this.choiceDistrictOptions(payload.district.district_options)
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private choiceVarietyOptions (data: any) {
    let ret = []

    for (const datum of data) {
      ret.push(datum.variety_id)
    }

    return ret
  }

  private choiceDistrictOptions (data: any) {
    let ret = []

    for (const datum of data) {
      ret.push(datum.district_id)
    }

    return ret
  }

  private getNewsBoardContent (newsBoardId: string) {
    (async () => {
      const result = await NewsBoardContentListApi.getDetail(newsBoardId, '', '')
      if (result.isOk()) {
        const payload = result.getPayload()
        this.newsBoardContentData = payload.news_board_contents
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private displayContentTypeName (data: any): string {
    if (data.content_file !== '') {
      return 'ファイル'
    } else if (data.content_url !== '') {
      return 'URL'
    } else {
      return '-'
    }
  }

  private displayDate (date: string): string {
    const dateObj = new Date(date)
    return dateObj.getFullYear() + '年' + (dateObj.getMonth() + 1) + '月' + dateObj.getDate() + '日'
  }

  private doCancel () {
    this.$router.push('/news-board').catch(e => {})
  }

  private doActualCreate () {
    const path = '/news-board/' + this.newsBoardId + '/content/create'
    this.$router.push(path).catch(e => {})
  }

  private doActualEdit (newsBoardContentId: string) {
    const path = '/news-board/' + this.newsBoardId + '/content/' + newsBoardContentId
    this.$router.push(path).catch(e => {})
  }

  private doNewsBoardEdit () {
    const path = '/news-board/' + this.newsBoardId + '/edit'
    this.$router.push(path).catch(e => {})
  }

  // 品種情報取得
  private getVarieties () {
    (async () => {
      this.showLoading = true
      const data = {
        word: '',
        order_name: 'variety_name',
        sort: true
      }

      const result = await VarietyListApi.getVarietyList(data)

      if (result.isOk()) {
        this.varietyData = result.getPayload().results
        if (result.getPayload().result_count === 0) {
          this.alertText = ''
          this.alertTitle = '品種が未登録です。品種を登録してから操作をしてください。'
          this.show400ErrorMessage = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showLoading = false
    })()
  }

  /* 地区取得 */
  private getDistricts () {
    (async () => {
      this.showLoading = true
      const data : any = {
        sortName: 'district_name',
        sort: 'asc',
        text: ''
      }

      const result = await DistrictListApi.getDistrictList(data)

      if (result.isOk()) {
        this.districtData = result.getPayload().results
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private async getNewsBoardFile (id: number, content_name: string) {
    const objectURL = await GetNewsBoardFileApi.getNewsBoardFile(id)
    if (typeof objectURL === 'string') {
      let link = document.createElement('a')
      document.body.appendChild(link)
      link.href = objectURL
      link.download = content_name
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(objectURL)
    } else {
      Vue.prototype.$alert.toast({ text: 'ファイル取得に失敗しました。', type: 1 })
    }
  }
}
